import script from "./CustomResourceApplyBDZB.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplyBDZB.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplyBDZB.vue?vue&type=style&index=0&id=0d776e63&lang=less&scope=true"

const __exports__ = script;

export default __exports__